import { makeStateKey } from "@angular/platform-browser";

export const SITE_CONFIG_KEY = makeStateKey<string>('SITE_CONFIG');